import React from "react";

const comparar = (a, b) => String(a).localeCompare(String(b), "es", { numeric: true, sensitivity: "base" });

export default function ReglasAgrupadas({ reglas, tipo, children, soloRecursos = false, tarjetas = false }) {
  const estanques = new Map();
  for (const regla of reglas) {
    const estanqueId = regla.estanqueId ?? regla.EstanqueId ?? regla.grupoId ?? "sin-estanque";
    if (!estanques.has(estanqueId)) estanques.set(estanqueId, {
      nombre: regla.estanqueNombre ?? regla.EstanqueNombre ?? regla.grupo ?? `Estanque ${estanqueId}`, recursos: new Map(),
    });
    const estanque = estanques.get(estanqueId);
    const sensor = tipo === "sensores" || (tipo === "mixto" && regla.sub === "sensores");
    const id = (sensor ? (regla.sensorId ?? regla.SensorId) : (regla.efectorId ?? regla.EfectorId)) ?? regla.recursoId;
    const key = `${sensor ? "sensor" : "efector"}-${id}`;
    if (!estanque.recursos.has(key)) estanque.recursos.set(key, {
      nombre: (sensor ? (regla.sensorNombre ?? regla.SensorNombre) : (regla.efectorNombre ?? regla.EfectorNombre)) ?? regla.recursoNombre ?? `#${id}`,
      etiqueta: sensor ? "Sensor" : "Efector", reglas: [],
    });
    estanque.recursos.get(key).reglas.push(regla);
  }
  return <div className="space-y-5">{[...estanques].sort((a,b) => comparar(a[1].nombre,b[1].nombre) || comparar(a[0],b[0])).map(([id, estanque]) =>
    <section key={id} className={soloRecursos ? "space-y-4" : "rounded-xl border border-slate-600 p-3 sm:p-4 space-y-4"}>
      {!soloRecursos && <h3 className="text-lg font-bold text-cyan-200 break-words">Estanque: {estanque.nombre}</h3>}
      {[...estanque.recursos].sort((a,b) => comparar(a[1].etiqueta,b[1].etiqueta) || comparar(a[1].nombre,b[1].nombre) || comparar(a[0],b[0])).map(([key, recurso]) =>
        <section key={key} className="min-w-0 space-y-2">
          <h4 className="text-emerald-300 font-semibold break-words">{recurso.etiqueta}: {recurso.nombre} <span className="text-sm text-slate-400">({recurso.reglas.length} {recurso.reglas.length === 1 ? "regla" : "reglas"})</span></h4>
          <div className={tarjetas ? "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" : "space-y-2"}>
            {recurso.reglas.sort((a,b) => comparar(a.nombre ?? "",b.nombre ?? "") || comparar(a.id ?? a.key,b.id ?? b.key)).map(children)}
          </div>
        </section>)}
    </section>)}</div>;
}
